import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  html, body {
    height: 100%;
    margin: 0;
    overflow: hidden;
  }

  #root {
    min-height: 0;
    height: 100vh;
    overflow: hidden;
  }
`;

export default GlobalStyle;
